export enum EditSessionTabs {
  TRACK_DETAILS = 'Track Details',
  SESSION_DETAILS = 'Session Details'
}
